const VISUAL_FLAG_TYPES = {
    OFFICIAL_PARKING: 'official_parking',
};
export { VISUAL_FLAG_TYPES };
